import { Link } from "react-router-dom";
import "@esri/calcite-components/dist/components/calcite-button";
import "../index.css";
import { useAuth } from "../components/AuthProvider";

interface NavBarProps {
    productName?: string;
}

export default function NavBar({ productName }: NavBarProps) {
    // Authentication
    const { token, authUrlPath } = useAuth();

    return (
        <>
            <nav className="bg-[#2b2b2b] w-100 px-8 md:px-auto">
                <div className="max-w-screen-xl mx-auto h-16 flex items-center mx-auto md:px-4 container">
                    <ul className="flex items-center space-x-6">
                        <li>
                            <div>
                                <Link
                                    to={token ? `/${authUrlPath}` : "/"}
                                    className="text-gray-400 link-hover-effect"
                                >
                                    Home
                                </Link>
                            </div>
                        </li>
                        {productName && (
                            <li>
                                <div>
                                    <span className="text-gray-400">{productName}</span>
                                </div>
                            </li>
                        )}
                    </ul>
                </div>
            </nav>
        </>
    );
}
